import { Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { union_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { equals, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { op_PlusPlus } from "../fable_modules/Feliz.Bulma.3.0.0/Operators.fs.js";
import { Fa_IconOption, Fa_ISize, Fa_i } from "../fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { Fetched$1_toOption_50D43789, useFeliz_React__React_useFetch_Static_6ADA66EC } from "../hooks/UseFetch.fs.js";
import { config as config_1 } from "../Api/Projects.fs.js";
import { ProjectPage__get_Href, ProjectPage__get_ProjectId } from "../ClientTypes.fs.js";
import { getUser, getTokenProfile } from "../Api/Auth.fs.js";
import { useFeliz_React__React_useInfoPanel_Static, useFeliz_React__React_useSearchType_Static } from "../hooks/UseRouter.fs.js";
import { defaultArg, some } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { Dashboard } from "../Dashboard/Dashboard.fs.js";
import { Progress } from "../Progress/Progress.fs.js";
import { ModelViewer } from "../ModelViewer/ModelViewer.fs.js";
import { Home } from "./Home.fs.js";
import { Definition } from "../Definition/Definition.fs.js";
import { Admin } from "../Admin/Admin.fs.js";
import { Context_ProjectContext, ProjectContext } from "../hooks/UseProjectContext.fs.js";
import { Header } from "./Header.fs.js";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { defaultOf } from "../fable_modules/Feliz.2.9.0/../Feliz.Router.4.0.0/../fable-library-js.4.24.0/Util.js";
import { Search } from "../Search/Search.fs.js";
import { InfoPanelType, InfoPanel } from "../InfoPanels/InfoPanel.fs.js";
import "./Project.scss";


export class MobileFocus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Filter", "Content", "Results", "InfoPanel"];
    }
}

export function MobileFocus_$reflection() {
    return union_type("EPM.App.Project.ProjectPage.MobileFocus", [], MobileFocus, () => [[], [], [], []]);
}

function navBarButton(isActive, buttonIcon, onClick) {
    return createElement("div", createObj(Helpers_combineClasses("navbar-item", toList(delay(() => append(singleton(["className", "is-tab"]), delay(() => append(isActive ? singleton(["className", "is-active"]) : empty(), delay(() => {
        let elems_1, elems;
        return singleton((elems_1 = [createElement("span", createObj(Helpers_combineClasses("icon", ofArray([op_PlusPlus(["className", "is-medium"], isActive ? ["className", "has-text-white"] : ["className", "has-text-primary-dark"]), ["onClick", onClick], (elems = [Fa_i(ofArray([buttonIcon, new Fa_IconOption(0, [new Fa_ISize(3, [])])]), [])], ["children", reactApi.Children.toArray(Array.from(elems))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))]));
    })))))))));
}

export function Project(props) {
    let elems_1, elms, children_5, children_1, elems_2, children_3, elems_5, elems_6;
    const configFetch = useFeliz_React__React_useFetch_Static_6ADA66EC(config_1, ProjectPage__get_ProjectId(props.projectPage), [ProjectPage__get_ProjectId(props.projectPage)]);
    const profileOpt = Fetched$1_toOption_50D43789(useFeliz_React__React_useFetch_Static_6ADA66EC(getTokenProfile, undefined, []));
    const userOpt = Fetched$1_toOption_50D43789(useFeliz_React__React_useFetch_Static_6ADA66EC(getUser, undefined, []));
    const patternInput = reactApi.useState(new MobileFocus(1, []));
    const setMobileTab = patternInput[1];
    const currentMobileTab = patternInput[0];
    const searchResultsOpt = useFeliz_React__React_useSearchType_Static();
    const infoPanelOpt = useFeliz_React__React_useInfoPanel_Static();
    let matchResult, failed, config, profile, user;
    switch (configFetch.tag) {
        case 3: {
            matchResult = 1;
            failed = configFetch.fields[0];
            break;
        }
        case 1: {
            matchResult = 2;
            break;
        }
        case 2: {
            if (profileOpt != null) {
                if (userOpt != null) {
                    matchResult = 3;
                    config = configFetch.fields[0];
                    profile = profileOpt;
                    user = userOpt;
                }
                else {
                    matchResult = 4;
                }
            }
            else {
                matchResult = 4;
            }
            break;
        }
        default:
            matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return createElement("div", createObj(Helpers_combineClasses("notification", ofArray([["className", "is-info"], ["children", "Prepairing to get project config"]]))));
        case 1:
            return createElement("article", createObj(Helpers_combineClasses("message", ofArray([["className", "is-danger"], (elems_1 = [createElement("div", createObj(Helpers_combineClasses("message-header", singleton_1(["children", "Something has gone wrong"])))), (elms = toList(delay(() => {
                switch (failed.tag) {
                    case 0: {
                        const pd = failed.fields[1];
                        console.error(some(pd));
                        return singleton(createElement("p", {
                            children: [defaultArg(pd.Detail, pd.Title)],
                        }));
                    }
                    case 1: {
                        const matchValue_1 = failed.fields[0];
                        switch (matchValue_1.tag) {
                            case 2: {
                                console.error(some(matchValue_1.fields[0]));
                                return singleton(createElement("p", {
                                    children: ["Unable get project config"],
                                }));
                            }
                            case 3: {
                                const n = matchValue_1.fields[0];
                                console.error(some(n));
                                return singleton(createElement("p", {
                                    children: [`Network error: ${n.message}`],
                                }));
                            }
                            case 0: {
                                const n_1 = matchValue_1.fields[0];
                                console.error(some(n_1));
                                return singleton(createElement("p", {
                                    children: [`Could not start to get the project config: ${n_1.message}`],
                                }));
                            }
                            default: {
                                console.error(some(matchValue_1.fields[0]));
                                return singleton(createElement("p", {
                                    children: ["Unable to understand project config"],
                                }));
                            }
                        }
                    }
                    default: {
                        console.error(some(failed.fields[0]));
                        return singleton(createElement("p", {
                            children: ["Something major has gone wrong"],
                        }));
                    }
                }
            })), createElement("div", {
                className: "message-body",
                children: reactApi.Children.toArray(Array.from(elms)),
            }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
        case 2:
            return createElement("div", createObj(Helpers_combineClasses("notification", ofArray([["className", "is-info"], ["children", "Fetching project config"]]))));
        case 3: {
            let page;
            const matchValue_2 = props.projectPage;
            page = ((matchValue_2.tag === 2) ? createElement(Dashboard, {
                projectId: matchValue_2.fields[0],
            }) : ((matchValue_2.tag === 3) ? createElement(Progress, {
                projectId: matchValue_2.fields[0],
            }) : ((matchValue_2.tag === 4) ? createElement(ModelViewer, {
                projectId: matchValue_2.fields[0],
                initialModelId: matchValue_2.fields[1],
            }) : ((matchValue_2.tag === 0) ? createElement(Home, {
                projectId: matchValue_2.fields[0],
            }) : ((matchValue_2.tag === 1) ? createElement(Definition, {
                projectId: matchValue_2.fields[0],
            }) : ((matchValue_2.tag === 6) ? (`QRCode: ${matchValue_2.fields[0]} - ${matchValue_2.fields[1]} - ${matchValue_2.fields[2]}`) : createElement(Admin, {
                projectId: matchValue_2.fields[0],
                adminPage: matchValue_2.fields[1],
            })))))));
            let breadcrumb;
            const elms_1 = singleton_1((children_5 = ofArray([(children_1 = singleton_1(createElement("a", createObj(ofArray([["href", ProjectPage__get_Href(props.projectPage)], (elems_2 = [createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "is-small"], ["children", Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-home"])), [])]])))), createElement("span", {
                children: ["Home"],
            })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), createElement("li", {
                children: reactApi.Children.toArray(Array.from(children_1)),
            })), (children_3 = singleton_1(createElement("a", {
                children: "A",
                href: "A",
            })), createElement("li", {
                children: reactApi.Children.toArray(Array.from(children_3)),
            }))]), createElement("ul", {
                children: reactApi.Children.toArray(Array.from(children_5)),
            })));
            breadcrumb = createElement("nav", {
                className: "breadcrumb",
                children: reactApi.Children.toArray(Array.from(elms_1)),
            });
            const contextValue = new ProjectContext(ProjectPage__get_ProjectId(props.projectPage), config, profile.profile, user);
            let child_7;
            const xs_20 = [createElement(Header, null), createElement("section", createObj(ofArray([["className", join(" ", ["project", "columns", "is-gapless"])], (elems_5 = toList(delay(() => {
                let matchValue_3, entityType_1, projectId_8;
                return append((matchValue_3 = searchResultsOpt, (matchValue_3 == null) ? singleton(defaultOf()) : ((entityType_1 = matchValue_3, singleton(createElement(Search, (projectId_8 = ProjectPage__get_ProjectId(props.projectPage), {
                    entityType: entityType_1,
                    isVisibleMobileFilter: equals(currentMobileTab, new MobileFocus(0, [])),
                    isVisibleMobileResults: equals(currentMobileTab, new MobileFocus(2, [])),
                    projectId: projectId_8,
                })))))), delay(() => append(singleton(createElement("div", createObj(Helpers_combineClasses("column", toList(delay(() => append(singleton(["className", "project-content"]), delay(() => append(!equals(currentMobileTab, new MobileFocus(1, [])) ? singleton(["className", "is-hidden-mobile"]) : empty(), delay(() => {
                    let elems_4;
                    return singleton((elems_4 = [createElement("div", {
                        className: "project-page",
                        children: page,
                    })], ["children", reactApi.Children.toArray(Array.from(elems_4))]));
                })))))))))), delay(() => {
                    const matchValue_4 = infoPanelOpt;
                    if (matchValue_4 == null) {
                        return empty();
                    }
                    else {
                        const matchValue_5 = matchValue_4;
                        if (matchValue_5.tag === 0) {
                            return singleton(createElement(InfoPanel, {
                                key: "00000000-0000-0000-0000-000000000000",
                                $key: "00000000-0000-0000-0000-000000000000",
                                projectId: ProjectPage__get_ProjectId(props.projectPage),
                                isVisibleMobile: equals(currentMobileTab, new MobileFocus(3, [])),
                                infoPanelType: new InfoPanelType(0, []),
                            }));
                        }
                        else {
                            const entityId_1 = matchValue_5.fields[0];
                            return singleton(createElement(InfoPanel, {
                                key: entityId_1,
                                $key: entityId_1,
                                projectId: ProjectPage__get_ProjectId(props.projectPage),
                                isVisibleMobile: equals(currentMobileTab, new MobileFocus(3, [])),
                                infoPanelType: new InfoPanelType(1, [matchValue_5.fields[1], entityId_1]),
                            }));
                        }
                    }
                }))));
            })), ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), createElement("nav", createObj(Helpers_combineClasses("navbar", ofArray([op_PlusPlus(op_PlusPlus(op_PlusPlus(["className", "is-fixed-bottom"], ["className", "is-hidden-tablet"]), ["className", "is-radiusless"]), ["className", "mobile-panel-selection"]), (elems_6 = toList(delay(() => append(singleton(navBarButton(equals(currentMobileTab, new MobileFocus(0, [])), new Fa_IconOption(11, ["fas fa-filter"]), (_arg) => {
                setMobileTab(new MobileFocus(0, []));
            })), delay(() => append(singleton(navBarButton(equals(currentMobileTab, new MobileFocus(2, [])), new Fa_IconOption(11, ["fas fa-list"]), (_arg_1) => {
                setMobileTab(new MobileFocus(2, []));
            })), delay(() => append(singleton(navBarButton(equals(currentMobileTab, new MobileFocus(1, [])), new Fa_IconOption(11, ["fas fa-dot-circle"]), (_arg_2) => {
                setMobileTab(new MobileFocus(1, []));
            })), delay(() => ((infoPanelOpt != null) ? singleton(navBarButton(equals(currentMobileTab, new MobileFocus(3, [])), new Fa_IconOption(11, ["fas fa-info"]), (_arg_3) => {
                setMobileTab(new MobileFocus(3, []));
            })) : singleton(navBarButton(equals(currentMobileTab, new MobileFocus(3, [])), new Fa_IconOption(11, ["fas fa-ban"]), (value_58) => {
            }))))))))))), ["children", reactApi.Children.toArray(Array.from(elems_6))])]))))];
            child_7 = react.createElement(react.Fragment, {}, ...xs_20);
            return reactApi.createElement(Context_ProjectContext.Provider, {
                value: contextValue,
            }, child_7);
        }
        default:
            return defaultOf();
    }
}

